import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCalendarDuotone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <rect
      width={19.11}
      height={11.14}
      transform="translate(2.447 10.408)"
      fill="#475569"
    />
    <path
      d="M2.91 21.09q-.46-.47-.46-1.13v-9.55h19.1v9.55c0 .42-.16.83-.46 1.13q-.47.46-1.13.46H4.04c-.42 0-.83-.16-1.13-.46"
      fill="#ECF1FF"
    />
    <path
      d="M2.91 5.3q.47-.46 1.13-.46h15.92c.42 0 .83.16 1.13.46q.46.47.46 1.13v3.98H2.45V6.43c0-.42.17-.83.46-1.13"
      fill="white"
    />
    <path
      d="M4.04 4.84c-.42 0-.83.16-1.13.46q-.46.47-.46 1.13v13.53c0 .42.17.83.46 1.13q.47.46 1.13.46h15.92c.42 0 .83-.16 1.13-.46q.46-.47.46-1.13V6.43c0-.42-.16-.83-.46-1.13q-.47-.46-1.13-.46z"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.45 10.4h19.1"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.43 2.45v4.77"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.57 2.45v4.77"
      stroke="#5C5CFF"
      strokeWidth={1.71}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIconCalendarDuotone;
